<template>
  <v-container grid-list-md fluid text-center>
    <v-layout>
      <v-flex>
        <Tabs />
        <NodeBtn v-if="!showStatic" />
        <NodeDialog v-if="!showStatic" />
        <NodeShow v-if="!showStatic" />
        <Table />
        <CourseDetial />
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import Tabs from "../components/Tabs";
import NodeBtn from "../components/Node/NodeBtn";
import NodeDialog from "../components/Node/NodeDialog";
import NodeShow from "../components/Node/NodeShow";
import Table from "../components/Table";
import CourseDetial from "../components/CourseDetial";

export default {
  components: {
    Tabs,
    NodeBtn,
    NodeDialog,
    NodeShow,
    Table,
    CourseDetial,
  },
  computed: {
    showStatic() {
      return this.$store.state.showStatic;
    },
  },
  mounted() {
    this.$store.commit("clearInfo");
  },
};
</script>
